import React, { useEffect, useState } from "react";
import { Button, Select, Table, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import { EyeFilled } from "@ant-design/icons";
import "../../css/common.css";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import { formatDate } from "../../../utils/dateFormatter";

const CompanySoundLogBookList = () => {
  const navigate = useNavigate();
  const [page_loader, set_page_loader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [ship_id, set_ship_id] = useState("");
  const [ship_table_list, set_ship_table_list] = useState([]);

  const SHIP_LIST_API = () => {
    const FORM_DATA = new FormData();
    try {
      post(ApiURL.list_ships_view_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          set_ship_table_list(res?.ships);
          set_ship_id(res?.ships[0]?.id);
          LIST_SOUNDING_LOGBOOK_API(res?.ships[0]?.id);
        }
      });
    } catch (error) {
      console.error("Error fetching ship list:", error);
    } finally {
    }
  };

  const LIST_SOUNDING_LOGBOOK_API = (ship_id) => {
    set_page_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("ship_id", ship_id);
      post(ApiURL.list_sound_log_books_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          setFilteredData(res?.sound_log_books);
          set_page_loader(false);
        } else {
          set_page_loader(false);
        }
      });
    } catch (error) {
      console.error("Error fetching Staff list:", error);
      set_page_loader(false);
    }
  };

  useEffect(() => {
    SHIP_LIST_API();
  }, []);

  const columns = [
    {
      title: "Id",
      dataIndex: "id",
      align: "center",
      key: "id",
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: "Logbook Name",
      dataIndex: "name",
      align: "center",
      key: "name",
      render: (text, record, index) => `${text}_(${index + 1})`,
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      align: "center",
      key: "created_at",
      render: (text, record) => formatDate(record?.created_at),
    },
    {
      title: "Updated Date",
      dataIndex: "updated_at",
      align: "center",
      key: "updated_at",
      render: (text, record) => formatDate(record?.updated_at),
    },

    {
      title: "Status",
      dataIndex: "status",
      align: "center",
      key: "status",
      render: (text, record) => {
        if (record?.status) {
          return <span className="table-status-activate">Active</span>;
        } else {
          return <span className="table-status-deactivate">Inactive</span>;
        }
      },
    },

    {
      title: "Action",
      align: "center",
      key: "Action",
      render: (text, record) => (
        <Tooltip title="View">
          <Button
            type="primary"
            size="small"
            onClick={() => navigate(`/company-view-sound-log/${btoa(record?.id)}`)}
            style={{ marginRight: "5px" }}
            icon={<EyeFilled />}
          />
        </Tooltip>
      ),
    },
  ];

  return (
    <div>
      <div className="row">
        <div className="col-3">
          <label className="block-label">Select Ship</label>
          <Select
            placeholder="---- Select Ship ----"
            style={{ width: "100%" }}
            value={ship_id}
            onChange={(value) => {
              set_ship_id(value);
              LIST_SOUNDING_LOGBOOK_API(value);
            }}
          >
            {ship_table_list?.length > 0 &&
              ship_table_list
                .filter((ship) => !ship.soft_delete)
                .map((ship) => (
                  <Select.Option key={ship.id} value={ship.id}>
                    {ship.vessel_name}
                  </Select.Option>
                ))}
          </Select>
        </div>
      </div>

      <div className="row" style={{ padding: "10px" }}>
        <div className="col-3" style={{ marginLeft: "5px", alignSelf: "end" }}>
          <div className="theme-content-title text-left">
            <h3>Sounding Logbook Information</h3>
          </div>
        </div>
        <div className="col-3"></div>
        <div className="col-6" style={{ display: "flex", justifyContent: "flex-end" }}>
          <div className="d-flex align-items-center">
            <Button
              type="primary"
              className="save_btn"
              onClick={() => navigate("/view-audit-trail-sounding-log")}
            >
              Audit Trail
            </Button>
          </div>
        </div>
      </div>
      <Table
        bordered
        columns={columns}
        dataSource={filteredData}
        pagination={{ pageSize: 10 }}
        rowKey="key"
        loading={page_loader}
        className="custom-table"
      />
    </div>
  );
};

export default CompanySoundLogBookList;
